module.exports = __webpack_public_path__ + "img/pay.ee0dfe3f.svg";